// Updated LoginPage.js to include PublicHeader and PublicFooter
import React, { useState } from 'react';
import { useAuth } from './auth-context';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import { apiFetch } from '../api/api';
import { toast } from 'react-toastify';

import '../App.css';



export default function LoginPage() {
    const { setFromToken } = useAuth(); // we’ll set context from the token
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('returnTo') || (location.state?.from?.pathname === '/devices' ? '/devices' : '/homepage');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState('');
    const wrap = { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh', background:'#f7f8fb', padding:16 };
    const panel = { width:560, maxWidth:'96vw', background:'#fff', border:'1px solid #eee', borderRadius:12, padding:16, boxShadow:'0 10px 30px rgba(0,0,0,.06)' };
    const row = { display:'flex', flexDirection:'column' };
    const label = { fontSize:13, color:'#555', marginBottom:'6px', padding:'10px 10px 10px 10px' };
    const input = { padding:'10px 12px', border:'1px solid #ddd', borderRadius:8 };
    const btnPrimary = { border:0, background:'#0f62fe', color:'#fff', borderRadius:8, padding:'10px 14px', cursor:'pointer' };
    const btnLight = { border:'1px solid #ddd', background:'#fff', borderRadius:8, padding:'10px 14px', cursor:'pointer' };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError('');

console.log('[LOGIN PAGE] submit', { email: email.trim(), host: window.location.hostname, origin: window.location.origin, returnTo });

        try {
          const res = await apiFetch('/auth/login', {
            method: 'POST',
            body: { email: email.trim(), password },
          });

          // Your server typically returns { accessToken, user, ... }
          if (res?.accessToken) {
            try { localStorage.setItem('accessToken', res.accessToken); } catch {}
            try { setFromToken(res.accessToken); } catch {}

          }

          // Pick a default org to store; adjust to your response shape
          const defaultOrgId =
            res?.defaultOrgId ||
            res?.orgId ||
            res?.memberships?.find?.(m => m.defaultOrg)?.orgId ||
            null;

          if (defaultOrgId) {
            try {
              localStorage.setItem('activeOrgId', String(defaultOrgId));
              localStorage.setItem('org-update', String(Date.now()));
            } catch {}
          }

          toast.success('Welcome back!');

          if (/^https?:\/\//i.test(returnTo)) {
              window.location.assign(returnTo);
              return;
          }

          navigate(returnTo, { replace: true });
        } catch (err) {
console.error('[LOGIN PAGE] failed', { message: err?.message, status: err?.response?.status, data: err?.response?.data }); const msg = err?.response?.data?.message || err?.message || 'Invalid email or password';


          setError(msg);
          // Optional toast if you like:
          toast.error(msg);
        } finally {
          setSubmitting(false);
        }
      };

    return (
        <div>
            <PublicHeader />
            <div className="form-container">
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                  <div style={{display:'flex', justifyContent:'left'}}>
                    <label style={label}>Email:</label>
                    <input type="email" style={{width:"90%"}}  value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <div style={{display:'flex', justifyContent:'left'}}>
                    <label style={label}>Password:</label>
                    <input type="password" style={{width:"80%"}} value={password} onChange={(e) => setPassword(e.target.value)} required />
                  </div>
                    <button type="submit">Login</button>
                </form>
                <div className="link-buttons">
                    <Link to="/create-account">Create Account</Link>
                    <Link to="/forgot-password">Forgot Password</Link>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
}
